import React from 'react';
import { Form } from 'react-bootstrap';
import { Slider, createTheme, ThemeProvider, InputAdornment } from '@material-ui/core';
import { SelectInput, TextInput } from '../../../Helpers/Inputs';
import { EditableBasicInfoSummary } from "../../Common/SubComponents/BasicInfoSummary";
import NumberFormatDollars from '../../../Helpers/Formatters/NumberFormatDollars';
import HealthClass from './HealthClass';
import CoverageLengths from '../../../Helpers/Lists/CoverageLengths/TermCoverageLengths';
import DropDownIcon from'../../../../icons/arrow_drop_down.svg';

const quoterTheme = {
    typography: {
      fontFamily: "museo-sans",
      body1: {
        fontSize: 14,
        fontWeight: 500,
      },
    },
    overrides: {
      MuiFormControl: {
        root: {
          "&.coverage-amount": {
            display: "flex",
            alignItems: "center",
          },
          "&.coverage-amount .coverage-input": {
            display: "flex",
            width: 188,
            height: 47,
            alignItems: "center",
            borderRadius: 6,
  
          },
          "&.coverage-amount .coverage-input::before": {
            content: "none",
          },
          "&.coverage-amount .coverage-input::after": {
            content: "none",
          },
          "&.coverage-amount .coverage-input input": {
            padding: 0,
          },
        },
      },
  
      MuiInputBase: {
        input: {
          fontSize: 16,
        },
        root: {
          height: 56,
        },
      },
      MuiFilledInput: {
        root: {
          backgroundColor: "#f2f2f2",
        },
        underline: {
          "&::before": {
            borderBottom: "solid 2px #b2b2b2",
          },
          "&:hover::before": {
            borderBottomWidth: "2px",
          },
        },
        adornedEnd: {
          paddingRight: "0px",
        },
      },
      MuiFormLabel: {
        root: {
          fontSize: 16,
          color: "rgba(0,0,0,0.6)",
        },
      },
      MuiFormHelperText: {
        root: {
          marginTop: 0,
          paddingTop: 0,
        },
      },
      MuiInputLabel: {
        shrink: {
          color: "rgba(0,0,0,0.3) !important",
        },
      },
      MuiSelect: {
        fontSize: 16,
        icon: {
          color: "rgba(0,0,0,1)",
        },
        iconFilled: {
          right: 16,
        },
      },
      MuiSlider: {
        root: {
          height: 4,
          margin: "8px 0",
          padding: 0,
        },
        rail: {
          height: 4,
          borderRadius: 2,
          backgroundColor: " #ccc",
          opacity: 1,
        },
        track: {
          height: 4,
          borderRadius: 2,
        },
        mark: {
          display: "none",
        },
        thumb: {
          marginTop: -4,
        },
        markLabel: {
          top: 9,
          fontSize: 12,
          color: "#333",
          "&[style*='0%;']": {
            "left": "18px !important",
          },
          "&[style*='100%;']": {
            "right": "-15px !important",
            "left": "auto !important",
          },
        },
      },
      MuiSvgIcon: {
        root: {
          width: 24,
          height: 24,
          marginBottom: 1,
        },
      },
      MuiPaper: {
        outlined: {
          border: "none",
          boxShadow: "0 2px 3px rgba(0, 0, 0, 0.161)",
        },
      },
    },
  };

export default function GetQuote(props) {
    const healthClasses = HealthClass();
    const coverageLengths = CoverageLengths(props.isAmerico);
    const handleChange = (event, newValue) => {
        props.setCoverageAmount(newValue);
    };

    const { multiTermFilter } = props;

    return (
        <div className="coverage-selector-container">
            <h2>{props.isAmerico ? "Loan Protection Life Insurance" : "Term Life Insurance"}</h2>
            <EditableBasicInfoSummary
                    gender={props.basicInfo.gender}
                    state={props.basicInfo.state}
                    birthdate={props.basicInfo.birthdate || props.basicInfo.fakeBirthdate}
                    tobacco={props.basicInfo.tobacco}
                    height={props.basicInfo.height}
                    weight={props.basicInfo.weight}
                    showEditLink={true}
                    editLinkOnClick={() => {props.setOpenEditPopUp(true) }}
                />
            <ThemeProvider theme={(theme) => createTheme({
                ...quoterTheme,
            })}>
                <Form>
                    <div className='select-slide-container'>
                        <TextInput
                            name="coverageAmount"
                            id="coverageAmount"
                            label="Coverage Amount"
                            value={props.coverageAmount}
                            onChange={(e) => props.setCoverageAmount(parseInt(e.target.value, 10))}
                            InputProps={{
                                inputComponent: NumberFormatDollars,
                                endAdornment: (
                                    <InputAdornment position="end" className="text-input-carrot" disablePointerEvents>
                                      <DropDownIcon/>
                                    </InputAdornment>
                                  ),
                            }}
                        />
                        <div className="slider-container">
                            <Form.Group className="mr-2">
                                <Slider
                                    min={props.isAmerico ? 25000 : 100000}
                                    max={props.isAmerico ? 1000000 : 3000000}
                                    step={null}
                                    value={props.coverageAmount}
                                    onChange={handleChange}
                                    className="m-2"
                                    marks={props.marks}
                                />
                            </Form.Group>
                        </div>
                    </div>
                    <Form.Group>
                        <SelectInput
                            name="CoverageLength"
                            id="CoverageLength"
                            value={props.termLength}
                            hideEmptyOption
                            onChange={(e) => props.setTermLength(e.target.value)}
                            label="Years of Coverage"
                            selectOptions={coverageLengths}
                        />
                    </Form.Group>
                    <Form.Group>
                        <SelectInput
                            name="HealthClass"
                            id="HealthClass"
                            hideEmptyOption
                            value={props.healthClass}
                            onChange={(e) => props.setHealthClass(e.target.value)}
                            label="Health Rating"
                            selectOptions={healthClasses}
                        />
                    </Form.Group>
                </Form>
          </ThemeProvider>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/Quoters/CustomizeTerm/QuoterComponents/BasicInfoSummary.js